var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.itemSlots),function(name){return {key:name,fn:function(ref){
var item = ref.item;
return [_vm._t(name,null,{"item":item})]}}})],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }